import InterExtraBoldTtf from '../../../assets/fonts/Inter-ExtraBold.woff2';
import InterSemiBoldTtf from '../../../assets/fonts/Inter-SemiBold.woff2';
import AbBlank from '../../../assets/fonts/AdobeBlank.ttf.woff';

export default [
  {
    name: 'AbBlank',
    path: AbBlank,
  },
  {
    name: 'InterExtraBold',
    path: InterExtraBoldTtf,
  },
  {
    name: 'InterSemiBold',
    path: InterSemiBoldTtf,
  },
]
